import { core, type Json } from '../core/index.js';
import { filterFabricErrors } from '../errors/errors.js';
import { type FabricSetStorageOptions } from './types.js';

/**
 * 异步方法, 将数据存储在本地缓存中指定的 key 中。会覆盖掉原来该 key 对应的内容。除非用户主动删除或因存储空间原因被系统清理，否则数据都一直可用。单个 key 允许存储的最大数据长度为 1MB，所有数据存储上限为 10MB。
 * @param key 缓存key
 * @param data 缓存数据
 * @returns Promise<boolean>
 */
export const setStorage = (key: string, data: Json) => {
  return new Promise<boolean>((resolve, reject) => {
    core.call<'fabric_storage.setStorage', FabricSetStorageOptions, boolean>(
      'fabric_storage.setStorage',
      {
        key,
        data: JSON.stringify(data),
      },
      (result) => {
        const fabricErrors = filterFabricErrors(
          result.code,
          result.message,
          result.data
        );
        if (fabricErrors) {
          reject(fabricErrors);
        } else {
          resolve(result.data);
        }
      }
    );
  });
};
